<template>
  <div id="appcontent">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
onMounted(() => {
  document.title = "管理系统";
});
</script>

<style>
/*#app {*/
/*  font-family: Avenir, Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
/*  text-align: center;*/
/*  color: #2c3e50;*/
/*  margin-top: 60px;*/
/*}*/
</style>
